import React, { useState } from 'react';

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;700&family=DM+Sans:wght@300;400;500;600&display=swap');
.dn-page{font-family:'DM Sans',sans-serif;background:#f5f4f0;min-height:100vh;}

/* hero */
.dn-hero{position:relative;overflow:hidden;padding:4rem 2rem 3.5rem;background:linear-gradient(135deg,#7d3c00 0%,#a04000 50%,#7d3000 100%);}
.dn-orb{position:absolute;border-radius:50%;filter:blur(80px);opacity:.18;pointer-events:none;}
.dn-orb--a{width:500px;height:500px;background:radial-gradient(circle,#f39c12,transparent);top:-130px;right:-90px;}
.dn-orb--b{width:350px;height:350px;background:radial-gradient(circle,#e67e22,transparent);bottom:-90px;left:-60px;}
.dn-hero-inner{position:relative;z-index:1;max-width:720px;margin:0 auto;text-align:center;}
.dn-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.22);color:rgba(255,255,255,.88);font-size:.75rem;letter-spacing:.08em;padding:5px 14px;border-radius:999px;margin-bottom:1.25rem;}
.dn-h1{font-family:'Playfair Display',Georgia,serif;font-size:clamp(2rem,5vw,3.2rem);font-weight:700;color:#fff;line-height:1.15;margin:0 0 1rem;}
.dn-gold{background:linear-gradient(90deg,#ffd700,#f39c12);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
.dn-hero-sub{font-size:1rem;color:rgba(255,255,255,.7);line-height:1.7;max-width:54ch;margin:0 auto;}

/* body */
.dn-body{max-width:1100px;margin:0 auto;padding:3.5rem 2rem 5rem;}

/* methods row */
.dn-methods{display:grid;grid-template-columns:repeat(3,1fr);gap:1rem;margin-bottom:3rem;}
.dn-method{background:#fff;border-radius:14px;padding:1.5rem;text-align:center;border-top:4px solid var(--mc,#e67e22);box-shadow:0 2px 10px rgba(0,0,0,.05);transition:transform .2s,box-shadow .2s;}
.dn-method:hover{transform:translateY(-4px);box-shadow:0 10px 28px rgba(0,0,0,.1);}
.dn-method-icon{font-size:2rem;display:block;margin-bottom:.65rem;}
.dn-method-title{font-family:'Playfair Display',serif;font-size:1rem;font-weight:600;color:#0b3d4a;margin:0 0 .3rem;}
.dn-method-desc{font-size:.82rem;color:#777;line-height:1.55;margin:0;}

/* main content grid */
.dn-content{display:grid;grid-template-columns:1fr 1.4fr;gap:2rem;margin-bottom:2.5rem;}

/* QR card */
.dn-qr-card{background:#fff;border-radius:16px;padding:2rem;box-shadow:0 4px 24px rgba(0,0,0,.07);text-align:center;display:flex;flex-direction:column;align-items:center;gap:1rem;}
.dn-card-title{font-family:'Playfair Display',serif;font-size:1.25rem;font-weight:700;color:#0b3d4a;margin:0;}
.dn-qr-wrap{width:200px;height:200px;background:#f5f4f0;border-radius:12px;overflow:hidden;display:flex;align-items:center;justify-content:center;border:2px solid rgba(0,0,0,.07);}
.dn-qr-img{width:100%;height:100%;object-fit:contain;}
.dn-qr-fallback{display:flex;flex-direction:column;align-items:center;gap:.5rem;color:#bbb;font-size:.8rem;}
.dn-qr-fallback span:first-child{font-size:2.5rem;}
.dn-qr-note{font-size:.8rem;color:#999;line-height:1.5;max-width:20ch;}
.dn-upi-chip{background:linear-gradient(135deg,#0b3d4a,#21808d);color:#fff;border-radius:10px;padding:.85rem 1.1rem;width:100%;text-align:left;}
.dn-upi-label{font-size:.68rem;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:rgba(255,255,255,.55);margin-bottom:.25rem;}
.dn-upi-val{font-size:.92rem;font-weight:600;font-family:'Berkeley Mono',monospace;}

/* bank card */
.dn-bank-card{background:#fff;border-radius:16px;padding:2rem;box-shadow:0 4px 24px rgba(0,0,0,.07);}
.dn-detail{margin-bottom:1rem;}
.dn-detail:last-child{margin-bottom:0;}
.dn-detail label{display:block;font-size:.72rem;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:#aaa;margin-bottom:.35rem;}
.dn-detail-row{display:flex;gap:.5rem;align-items:center;}
.dn-detail-val{flex:1;background:#f8f7f5;border:1.5px solid rgba(0,0,0,.08);border-radius:8px;padding:.6rem .9rem;font-size:.9rem;font-family:'Berkeley Mono',ui-monospace,monospace;color:#1a1a1a;outline:none;cursor:default;}
.dn-copy-btn{padding:.55rem .9rem;background:linear-gradient(135deg,#e67e22,#f39c12);color:#fff;border:none;border-radius:8px;font-family:'DM Sans',sans-serif;font-size:.78rem;font-weight:600;cursor:pointer;white-space:nowrap;transition:transform .15s,box-shadow .15s;flex-shrink:0;}
.dn-copy-btn:hover{transform:translateY(-1px);box-shadow:0 4px 12px rgba(230,126,34,.35);}
.dn-copy-btn.copied{background:linear-gradient(135deg,#27ae60,#2ecc71);}

/* tax section */
.dn-tax{background:#fff;border-radius:16px;padding:2rem;box-shadow:0 4px 24px rgba(0,0,0,.07);}
.dn-tax-title{font-family:'Playfair Display',serif;font-size:1.25rem;font-weight:700;color:#0b3d4a;margin:0 0 1.5rem;}
.dn-tax-items{display:grid;grid-template-columns:repeat(3,1fr);gap:1rem;}
.dn-tax-item{display:flex;align-items:flex-start;gap:.85rem;padding:1.1rem;background:#f8f7f5;border-radius:12px;border-left:4px solid var(--tc,#e67e22);}
.dn-tax-icon{font-size:1.4rem;flex-shrink:0;margin-top:.05rem;}
.dn-tax-item h4{font-family:'DM Sans',sans-serif;font-size:.88rem;font-weight:600;color:#0b3d4a;margin:0 0 .25rem;}
.dn-tax-item p{font-size:.8rem;color:#777;line-height:1.55;margin:0;}

/* help bar */
.dn-help{text-align:center;margin-top:2rem;font-size:.9rem;color:#888;}
.dn-help a{color:#21808d;font-weight:600;text-decoration:none;}
.dn-help a:hover{text-decoration:underline;}

/* divider label */
.dn-rule{display:flex;align-items:center;gap:1rem;margin-bottom:1.75rem;}
.dn-rule-line{flex:1;height:1px;background:rgba(0,0,0,.08);}
.dn-rule-lbl{font-size:.68rem;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:#21808d;white-space:nowrap;}

@media(max-width:860px){.dn-content{grid-template-columns:1fr;}.dn-methods{grid-template-columns:1fr;}.dn-tax-items{grid-template-columns:1fr;}.dn-body{padding:2.5rem 1.25rem 4rem;}}
`;

const donateInfo = {
  upiId:          'vivekaseva.org@okhdfcbank',
  bankName:       'City Union Bank Ltd.',
  accountHolder:  'Viveka Seva Trust',
  accountNumber:  '5109 0901 0280 450',
  ifscCode:       'CIUB0000816',
  registrationNumber: 'UDYAM-KR-03-0569132',
  qrCodeUrl:      '/qrcodepng.png',
  taxNote: 'Section 80G certification is currently in progress. We are actively working towards obtaining it to provide tax benefits to our donors.',
  panId:'AAETXXXX3M',
};

const methods = [
  { icon:'📱', title:'UPI Payment',    desc:'Instant via Google Pay, PhonePe, Paytm, etc.',  color:'#e67e22' },
  { icon:'🏦', title:'Bank Transfer',  desc:'Direct transfer via Internet Banking.',           color:'#21808d' },
  { icon:'📲', title:'Scan QR Code',   desc:'Scan with any UPI app to donate instantly.',      color:'#8e44ad' },
];

const bankFields = [
  { label:'Bank Name',           value: donateInfo.bankName,       key:'bank'    },
  { label:'Account Holder',      value: donateInfo.accountHolder,  key:'holder'  },
  { label:'Account Number',      value: donateInfo.accountNumber,  key:'account' },
  { label:'IFSC Code',           value: donateInfo.ifscCode,       key:'ifsc'    },
  { label:'PAN Number',              value: donateInfo.panId,          key:'pan'     },
];

const taxItems = [
  { icon:'📋', h:'UDYAM Registration',       p: donateInfo.registrationNumber,                              color:'#21808d' },
  { icon:'⏳', h:'80G Certification In Progress', p: donateInfo.taxNote,                                        color:'#e67e22' },
  { icon:'✅', h:'Transparent & Accountable', p:'We maintain complete transparency and regular audits.',    color:'#27ae60' },
];

export default function Donate() {
  const [copied, setCopied] = useState(null);
  const [qrErr,  setQrErr]  = useState(false);

  const copy = (val, key) => {
    navigator.clipboard.writeText(val);
    setCopied(key);
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <div className="dn-page">
      <style>{CSS}</style>

      {/* HERO */}
      <div className="dn-hero">
        <div className="dn-orb dn-orb--a"/><div className="dn-orb dn-orb--b"/>
        <div className="dn-hero-inner">
          <div className="dn-badge">💛 Every Rupee Makes a Difference</div>
          <h1 className="dn-h1">Support Our <span className="dn-gold">Cause</span></h1>
          <p className="dn-hero-sub">Your donations help us continue our mission of education, healthcare, and social service across Karnataka.</p>
        </div>
      </div>

      <div className="dn-body">

        {/* METHODS */}
        <div className="dn-rule"><div className="dn-rule-line"/><span className="dn-rule-lbl">Ways to Donate</span><div className="dn-rule-line"/></div>
        <div className="dn-methods">
          {methods.map((m,i)=>(
            <div key={i} className="dn-method" style={{'--mc':m.color}}>
              <span className="dn-method-icon">{m.icon}</span>
              <p className="dn-method-title">{m.title}</p>
              <p className="dn-method-desc">{m.desc}</p>
            </div>
          ))}
        </div>

        {/* MAIN CONTENT */}
        <div className="dn-rule"><div className="dn-rule-line"/><span className="dn-rule-lbl">Payment Details</span><div className="dn-rule-line"/></div>
        <div className="dn-content">

          {/* QR Code */}
          <div className="dn-qr-card">
            <p className="dn-card-title">Quick Payment</p>
            <div className="dn-qr-wrap">
              {qrErr ? (
                <div className="dn-qr-fallback">
                  <span>📲</span>
                  <span>QR Code Image<br/>Add /qrcodepng.png<br/>to /public</span>
                </div>
              ) : (
                <img src={donateInfo.qrCodeUrl} alt="UPI QR Code" className="dn-qr-img"
                  onError={() => setQrErr(true)}
                />
              )}
            </div>
            <p className="dn-qr-note">Scan with any UPI app to donate instantly</p>
            <div className="dn-upi-chip">
              <div className="dn-upi-label">UPI ID</div>
              <div className="dn-upi-val">{donateInfo.upiId}</div>
            </div>
          </div>

          {/* Bank Details */}
          <div className="dn-bank-card">
            <p className="dn-card-title" style={{marginBottom:'1.5rem'}}>Bank Transfer Details</p>
            {bankFields.map(({label,value,key})=>(
              <div key={key} className="dn-detail">
                <label>{label}</label>
                <div className="dn-detail-row">
                  <input type="text" value={value} readOnly className="dn-detail-val"/>
                  <button
                    className={`dn-copy-btn${copied===key?' copied':''}`}
                    onClick={() => copy(value, key)}
                  >
                    {copied === key ? '✓ Copied' : '📋 Copy'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* TAX & REGISTRATION */}
        <div className="dn-rule"><div className="dn-rule-line"/><span className="dn-rule-lbl">Tax Benefits & Registration</span><div className="dn-rule-line"/></div>
        <div className="dn-tax">
          <div className="dn-tax-items">
            {taxItems.map((t,i)=>(
              <div key={i} className="dn-tax-item" style={{'--tc':t.color}}>
                <span className="dn-tax-icon">{t.icon}</span>
                <div><h4>{t.h}</h4><p>{t.p}</p></div>
              </div>
            ))}
          </div>
        </div>

        {/* HELP */}
        <p className="dn-help">
          <strong>Need help?</strong> Contact us at&nbsp;
          <a href="mailto:vivekaseva.org@gmail.com">vivekaseva.org@gmail.com</a>
        </p>
      </div>
    </div>
  );
}